import { DisabledPrompt, Link } from "bcms-react";
import { CenterContentContainer, ContentHeaderView, FormContainer, FormRowView, PageContainer, PageContentView } from 'components/shared';
import { FormButtonRow } from 'components/shared/containers/FormContainer';
import { UIButton, UIPasswordInput } from 'components/ui';
import React from 'react';
import "./mobile.css";
import "./styles.css";

/**
 * @function PasswordPage
 * @return {React.Component}
 * @exported true
 * @description The main component for PasswordPage
 */
export default function PasswordPage(props) {
  return (
    <PageContainer className="password-page">
        <PageContentView>
          <CenterContentContainer>
            <ContentHeaderView text="Password" />
            <p className="password-requirements-text">{'Passwords must be 9 to 32 characters long and must contain all of the following: a lowercase letter (a-z), an uppercase letter (A-Z), a digit (0-9), and a special character (~!@#$%^&*()[]{}<>_+-=/|\.,:;`’”?).'}</p>
            <FormContainer className="small-form-width">
              <FormRowView className="set-width" text="Current Password:">
                <UIPasswordInput />
              </FormRowView>
              <FormRowView text="New Password:">
                <UIPasswordInput />
              </FormRowView>
              <FormRowView text="Confirm Password:">
                <UIPasswordInput />
              </FormRowView>
              <FormButtonRow>
                <Link to="/profile" className="flex-width">
                  <UIButton className="secondary-button" text="Cancel" />
                </Link>
                <DisabledPrompt>
                  <UIButton className="primary-button" text="Update" />
                </DisabledPrompt>
              </FormButtonRow>
            </FormContainer>
          </CenterContentContainer>
        </PageContentView>
    </PageContainer>
  )
}
